import { LeadType } from '../../../shared/constants/Tracking.constants';
import {
  GatsbyPageContext,
  ICard,
  ICardWrapper,
  IContactForm,
  IParameter,
  IParentPage,
  ITabWrapper,
  IWizardComponent,
  WizardIntro,
  WizardStep,
} from '../../../types/shared/shared.types';

// eslint-disable-next-line no-shadow
export enum NavigationType {
  DEFAULT = 'default',
  RESTRICTED = 'restricted',
}

export interface IWizard {
  id: string;
  slug: string;
  version: string;
  parameterEmail: IParameter[];
  metadataTitle: string;
  showResultTitles: boolean;
  wizardName?: string;
  navigationType: NavigationType;
  enableReset: boolean;
  trackingName?: string;
  trackingLeadType: LeadType;
  title?: string;
  wizardIntro?: WizardIntro;
  body?: IWizardComponent;
  steps: WizardStep[];
  contactForm?: IContactForm;
  parentPage?: IParentPage;
  resultPage: {
    pageName: string;
    metadataTitle: string;
    body: (ICard | ICardWrapper | ITabWrapper)[];
    pageType: string;
    header: ICard;
    headerCards: ICard[];
    parentPage?: IParentPage;
  };
}

export interface WizardPageProps {
  data: {
    contentfulPageWizard: IWizard;
  };
  location: Location;
  pageContext: GatsbyPageContext;
}
